import usePendingAction, { requestWithCallbacks } from "shared/utils/usePendingAction.js";
import React from "react";
import "./Item.css";
import ButtonMflUser from "shared/components/buttons/ButtonMflUser.js";
import ButtonMflAssistantUser from "shared/components/buttons/ButtonMflAssistantUser.js";
import {
  deleteTeamNote,
} from "shared/services/api-assistant.js";

interface ItemRowTeamNoteProps {
  c: object;
  afterDelete?: func;
}

const ItemRowTeamNote: React.FC<ItemRowTeamNoteProps> = ({ c, afterDelete }) => {
  const { isPending, run } = usePendingAction();

  return (
    <div className="Item ItemRowWarning cursor-default text-main">
      <div className="d-flex flex-row flex-fill pb-1 pb-md-0 text-yellow">
        <div className="d-flex flex-fill">
          <i className="bi bi-sticky-fill me-1" />
          {c.note}
        </div>
        <div className="d-flex">
          <button
            className="btn btn-small text-danger"
            disabled={isPending}
            aria-label="Delete note"
            onClick={() => run(async () => {
              await requestWithCallbacks(deleteTeamNote, { params: { teamNoteId: c.id } });
              await afterDelete?.();
            })}
          >
            {isPending ? <span className="spinner-border spinner-border-sm primary-color" role="status" aria-label="Deleting note" /> : <i className="bi bi-x-circle" />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ItemRowTeamNote;
